"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.abbreviateMiddleName = void 0;
/**
 * Abbreviates a given full name by keeping the first name and the last name in full,
 * and abbreviating any middle names to their initials followed by a period.
 *
 * @param {string} fullname - The full name to be abbreviated. It should be in the format
 *                            "First Middle Last", where "Middle" represents one or more
 *                            middle names.
 * @returns {string} The abbreviated name in the format "First M. Last", where "M" represents
 *                   the initials of the middle names. If there is no middle name, it returns
 *                   "First Last". If only one name part is provided, it returns that part.
 *
 * @example
 * abbreviateMiddleName("John Doe") // Returns "John Doe"
 * abbreviateMiddleName("John Ronald Reuel Tolkien") // Returns "John R. R. Tolkien"
 * abbreviateMiddleName("Jane") // Returns "Jane"
 */
const abbreviateMiddleName = (fullname) => {
    const trimmedName = fullname.trim();
    const nameParts = trimmedName.split(/\s+/); // Split on one or more spaces
    if (nameParts.length <= 1) {
        return trimmedName; // Return as is for single-part names
    }
    const firstName = nameParts[0];
    const lastName = nameParts[nameParts.length - 1];
    const middleNames = nameParts.slice(1, -1);
    const abbreviatedMiddleNames = middleNames.map((name) => name.charAt(0).toUpperCase() + ".").join(" ");
    return [firstName, abbreviatedMiddleNames, lastName].filter(Boolean).join(" ");
};
exports.abbreviateMiddleName = abbreviateMiddleName;
